module.exports = __webpack_public_path__ + "files/549612dd66acfb04b84716d1f0ec67b5.png";